"use client"

import { getFormattedInCurrency } from "@/utils/prices"

import { Tag } from "./Tag"

/**
 * Renders a growth tag component.
 *
 * @param {Object} props
 * @param {number} props.growth - The growth value
 * @returns {JSX.Element}
 */
export const GrowthTag = ({ growth }) => {
  return <Tag key={growth} text={formatGrowth(growth)} variant={isTagIsSuccessful(growth) ? "success" : "danger"} />
}

/**
 * Renders a tag component to display the deviation.
 *
 * @param {Object} props
 * @param {number} props.deviation - The deviation value
 * @returns {JSX.Element}
 */
export const DeviationTag = ({ deviation }) => {
  return (
    <Tag
      key={deviation}
      text={formatDeviation(deviation)}
      variant={isTagIsSuccessful(deviation) ? "success" : "danger"}
    />
  )
}

/**
 * Checks if the growth value is successful.
 *
 * @param {number} growth - The growth value
 * @returns {boolean}
 */
const isTagIsSuccessful = (growth) => {
  return growth >= 0
}

/**
 * Formats the growth value.
 *
 * @param {number} growth - The growth value
 * @returns {string}
 */
const formatGrowth = (growth) => {
  const polarity = growth >= 0 ? "+" : ""
  growth = `${polarity}${growth} %`
  return growth.charAt(0) + " " + growth.substr(1)
}

/**
 * Formats the deviation value and returns it as a string.
 *
 * @param {number} deviation - The deviation value to be formatted
 * @param {string} locale - The locale to be used for formatting
 * @returns {string}
 */
const formatDeviation = (deviation, locale) => {
  const polarity = deviation >= 0 ? "+" : ""
  deviation = getFormattedInCurrency(deviation, "EUR", locale)
  deviation = `${polarity}${deviation}`
  return deviation.charAt(0) + " " + deviation.substr(1)
}
